import GiftInfoContextProvider from '@/contexts/GiftInfoContext'
import PaymentContextProvider from '@/contexts/PaymentContext'
import QrCodeContextProvider from '@/shahrzad-assets/shared-contexts/QrCodeContext'
import ConvesationTicketProvider from '@/contexts/ConversationTicket'
import RefreshPageProvider from '@/contexts/RefreshPage'
import Firebase from '@/shahrzad-assets/shared-utils/firebase'
import Routing from '@/routing/BaseRoutes'

const App = () => {
    return <QrCodeContextProvider>
        <GiftInfoContextProvider>
            <PaymentContextProvider>
                <ConvesationTicketProvider>
                    <RefreshPageProvider>
                        <Routing />
                        <Firebase />
                    </RefreshPageProvider>
                </ConvesationTicketProvider>
            </PaymentContextProvider>
        </GiftInfoContextProvider>
    </QrCodeContextProvider>
}

export default App;